// extracted by mini-css-extract-plugin
export var cardIcon = "_7e-5";
export var cardIconUnframed = "_7e-9";
export var checkboxCard = "_7e-0";
export var checkboxCardSelected = "_7e-4";
export var disabled = "_7e-2";
export var interactive = "_7e-1";
export var outerBorder = "_7e-3";
export var spacerMedium = "_7e-8";
export var spacerSmall = "_7e-7";
export var spacerXsmall = "_7e-6";